module.exports = __webpack_public_path__ + "static/media/logo-dark.b8774c48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-dark.svg
// module id = 211
// module chunks = 8